import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import Ava24 from 'dc/Ava24';

type WrapperProps = {
  $expanded: boolean;
};

export const Wrapper = styled(Wra16A)<WrapperProps>`
  width: 100%;
  cursor: pointer;
  background-color: ${props => (props.$expanded ? '#fff' : '#f4f7f9')};
`;

export const Spacer = styled.div`
  background: #f4f7f9;
`;

export const ListWrapper = styled.div`
  max-height: 400px;
  overflow: auto;
`;

type AvatarProps = {
  $position: number;
};

export const Avatar = styled(Ava24)<AvatarProps>`
  display: inline;
  position: absolute;
  left: ${props => `${props.$position}px`};
`;
